"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var AvatarContext_1 = __importDefault(require("./AvatarContext"));
var SkinColor_1 = __importDefault(require("./SkinColor"));
var Color_1 = __importDefault(require("./Color"));
function Skin(_a) {
    var maskID = _a.maskID;
    var color = react_1.useContext(AvatarContext_1.default).skinColor;
    return jsx_runtime_1.jsx(Color_1.default, { maskID: maskID, color: getSkinColor(color) }, void 0);
}
exports.default = Skin;
function getSkinColor(color) {
    if (color && color.startsWith('#'))
        return color;
    switch (color) {
        case SkinColor_1.default.Tanned:
            return '#FD9841';
        case SkinColor_1.default.Yellow:
            return '#F8D25C';
        case SkinColor_1.default.Pale:
            return '#FFDBB4';
        case SkinColor_1.default.Brown:
            return '#D08B5B';
        case SkinColor_1.default.DarkBrown:
            return '#AE5D29';
        case SkinColor_1.default.Black:
            return '#614335';
        case SkinColor_1.default.Light:
        default:
            return '#EDB98A';
    }
}
